export const CloningStatusEnum = Object.freeze({
  IN_PROGRESS: 'in_progress',
  DRAFT: 'draft',
  ERROR: 'error',
  COMPLETED: 'completed',
  SCHEDULED: 'scheduled',
})

export const LeaguesTypes = Object.freeze({
  LEAGUE: 'league',
  EVENT: 'event',
  TRIP: 'trip',
  NON_GOLF_EVENT: 'non-golf-event',
  DRIVE_CHIP_PUTT: 'dcp',
})

export const ALL_ENTRIES_FILTER_VALUE = 'all'
export const NONE_ENTRIES_FILTER_VALUE = 'none'

export const MAX_ALLOWED_SELECTED_LEAGUES = 50

export const CloningStepsEnum = Object.freeze({
  BROWSE: 1,
  RENAME: 2,
  CONFIG: 3,
  DATES: 4,
})

export const CloningStepsModals = Object.freeze({
  MISSING_LEAGUES_RENAMES: 'missing_leagues_renames',
  CANCEL_SESSION: 'cancel_session',
  SAVE_DRAFT_SUCCESS: 'save_draft_success',
  SAVE_DRAFT_ERROR: 'save_draft_error',
})

export const JobStatusEnum = Object.freeze({
  IN_PROGRESS: 'in_progress',
  COMPLETED: 'completed',
  SCHEDULED: 'scheduled',
  ERROR: 'error',
})

export const CLS_MODAL_QUERY_PARAM = 'clone_leagues_session'
